import { useMemo, useEffect } from 'react';
export const useMutationObserver = ({ element, callback, options, shouldObserve = true, }) => {
    const observer = useMemo(() => new MutationObserver(callback), [callback]);
    useEffect(() => {
        if (shouldObserve && element) {
            observer.observe(element, options);
        }
        return () => observer.disconnect();
    }, [shouldObserve, element, observer, options]);
};
//# sourceMappingURL=useMutationObserver.js.map